import { render, staticRenderFns } from "./CFilteredSelect.vue?vue&type=template&id=60c0f0cd&scoped=true&"
import script from "./CFilteredSelect.vue?vue&type=script&lang=js&"
export * from "./CFilteredSelect.vue?vue&type=script&lang=js&"
import style0 from "./CFilteredSelect.vue?vue&type=style&index=0&id=60c0f0cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0f0cd",
  null
  
)

export default component.exports